<template>
    <div>
        <p class="font-sm text-elev-blue-dim mb-2">
            <strong v-if="isLoadingSlotsForDate || slots.length || showFindNextButton"
            >{{ $t('Ledige klokkeslett') }} <span v-if="selectedDate">&minus; {{ selectedDate }}</span></strong>
        </p>

        <div class="text-center col-12" v-show="isLoadingSlotsForDate">
            <span class="spinner-border" role="status"></span>
        </div>

        <div v-show="!isLoadingSlotsForDate">
            <div class="alert alert-danger" v-if="message">
                <p class="m-0" v-html="message"></p>
            </div>

            <EventSlot v-for="(slot, i) in slots" :key="i" :slotData="slot" :canSelectTeacher="canSelectTeacher"></EventSlot>

            <div v-show="showFindNextButton">
                <button class="btn btn-primary btn-block py-3 fw-bold" @click="getNextAvailableDay">{{ $t('Finn neste ledige') }}</button>
                <button v-if="showFindNextButtonAllTeachers" class="btn btn-primary btn-block py-3 mt-2 fw-bold" @click="getNextAvailableDayAllTeachers">{{ $t('Se alle ledige') }}</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onUpdated, nextTick } from 'vue'
import Store from '../../state/calendarStore'
import EventSlot from './EventSlot'

const props = defineProps(['canSelectTeacher', 'selectedDate'])

// Computed
const slots = computed(() => Store.getSlots())
const showFindNextButton = computed(() => Store.state.showFindNextButton.value)
const message = computed(() => Store.getMessage())
const isLoadingSlotsForDate = computed(() => Store.getIsLoadingSlotsForDate())
const showFindNextButtonAllTeachers = computed(() => 
    props.canSelectTeacher && Store.state.teacherId.value > 0
)

// Methods
function getNextAvailableDay() {
    Store.getNextAvailableDay()
}

function getNextAvailableDayAllTeachers() {
    Store.setTeacherId(0)
    Store.getNextAvailableDay()
}

// Lifecycle
onUpdated(() => {
    nextTick(() => {
        Store.scrollToSlots()
    })
})
</script>
